// Site wide functions here
import domready from 'domready';
import tippy from './tippy';
import showSiteNav from './site-navigation';
import { initPasswordShowHide } from '../utils/password-show-hide';

const toolTipSelector = '.has-tooltip, .ifi-sign-question';

function init(args) {
    const { login } = args;
    domready(() => {
        const { siteNav } = login;

        // Show left aside
        if (siteNav) {
            showSiteNav(siteNav);
        }

        // Prepare tooltips
        tippy(toolTipSelector, {
            allowHTML: true,
            arrow: true,
            theme: 'light-border'
        });

        document.querySelectorAll('.show-hide[data-password-input]').forEach((togglePasswordEl) => {
            initPasswordShowHide(document.querySelector(togglePasswordEl.dataset.passwordInput), togglePasswordEl);
        });
    });
}

export default init;
